import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { GridOffset } from "@insite/mobius/GridContainer";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    containerWrapper: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            max-width: 1200px;
            margin: 0 auto;
            background-color: ${COLORS.background.darkWhite};
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            background-color: ${COLORS.background.base};
                        `,
                        css`
                            background-color: ${COLORS.background.base};
                        `,
                        css`
                            background-color: ${COLORS.background.base};
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    containerWrapper: {
        css: css`
            background-color: ${COLORS.background.darkWhite};
            max-width: 100%;
            margin: 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            background-color: ${COLORS.background.base};
                        `,
                        css`
                            background-color: ${COLORS.background.base};
                        `,
                        css`
                            background-color: ${COLORS.background.base};
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            padding: 0px;
            align-items: center;
            display: flex;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: auto !important;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin: 5px 10px;
                            `,
                            css`
                                margin: 5px 10px;
                            `,
                            css`
                                height: auto !important;
                                margin: 5px 10px;
                            `,
                            css`
                                margin: 5px 10px;
                            `,

                            null,
                        ],
                        "max",
                    );
                }}
            }
            img.masterflux {
                height: auto !important;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin: 5px 10px;
                            `,
                            css`
                                margin: 5px 10px;
                            `,
                            css`
                                height: auto;
                                margin: 5px 10px;
                            `,
                            css`
                                margin: 5px 10px;
                            `,

                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            padding: 20px 20px;
            display: flex;
            align-items: center;
            padding-bottom: 5px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                            justify-content: end;
                            padding-top: 5px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            > div[class^="HiddenStyle"] {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                display: none;
                            `,
                            css`
                                display: block;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            > div[class^="Wrapper"]:last-child {
                display: flex;
                justify-content: end;

                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
                > div:nth-child(2) {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    > div > div > select {
                        background-color: transparent;
                        border: 0;
                        padding-right: 10px;
                        height: 22px;
                        color: ${getColor("secondary")}!important;
                        font-family: Poppins !important;
                        font-size: 14px !important;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0.6px;
                    }
                    > div > div > select + span {
                        display: none;
                    }
                }
            }

            .header-auth-lang-wrapper {
                > ${GridOffset} {
                    align-items: center;
                }
            }
        `,
    },
    linkListHidden: {
        below: "lg",
        css: css`
            width: 500px;
            margin-right: -20px;
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            font-family: ${TYPOGRAPHY.fontFamily.base};
            span {
                color: ${getColor("secondary")}!important;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 300px !important;
                        `,
                        css`
                            width: 300px !important;
                            margin-right: -20px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.containerWrapper}>
        <StyledWrapper {...logoLinksSearchStyles.container}>
            <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
                <Hidden {...logoLinksSearchStyles.linkListHidden}>
                    <Zone contentId={id} zoneName="LinkList" />
                </Hidden>
                <Zone contentId={id} zoneName="Search" />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
